"use client";

import { MenuItem } from "@biom3/react";
import { useState } from "react";
import { useConnect } from "wagmi";

import { LinkWallet } from "@/components/core/LinkWallet";
import type { Wallet } from "@/types";
import { analytics } from "@analytics";

const LinkWalletButton = ({
  linkedWallets,
}: {
  linkedWallets: Wallet[] | undefined;
}) => {
  const { isIdle } = useConnect();
  const [isWalletConnectorsModalOpen, setIsWalletConnectorsModalOpen] =
    useState<boolean>(false);

  const linkWallet = () => {
    analytics.track(
      "PassportDashboardWalletsExternalWallets_LinkNewWalletButtonPressed",
    );
    setIsWalletConnectorsModalOpen(true);
  };

  return (
    <>
      <MenuItem
        emphasized
        sx={{
          mt: "base.spacing.x4",
          width: "100%",
        }}
        size="small"
        disabled={!isIdle}
        onClick={linkWallet}
      >
        <MenuItem.FramedIcon
          icon="Add"
          sx={{ borderRadius: "base.borderRadius.x2" }}
        />
        <MenuItem.Label>Link your wallet</MenuItem.Label>
      </MenuItem>
      <LinkWallet
        isConnectorsModalOpen={isWalletConnectorsModalOpen}
        onCloseConnectorsModal={() => setIsWalletConnectorsModalOpen(false)}
        linkedWallets={linkedWallets}
        onLinkPushPath={{ pathname: "/inventory" }}
        showImportOptions
        onLinkAnother={() => setIsWalletConnectorsModalOpen(true)}
        origin="ExternalWallets"
      />
    </>
  );
};

export { LinkWalletButton };
